// extracted by mini-css-extract-plugin
export var dataCell = "_s4-2";
export var dataRow = "_s4-0";
export var headerRow = "_s4-1";